module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加学生"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "insertUserForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.insertUserParam,
      "rules": _vm.ruleUser
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "昵称",
      "prop": "nickname"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.insertUserParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "nickname", $$v)
      },
      expression: "insertUserParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "微信号",
      "prop": "wechatAccount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手机号和微信号至少填一个"
    },
    model: {
      value: (_vm.insertUserParam.wechatAccount),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "wechatAccount", $$v)
      },
      expression: "insertUserParam.wechatAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "区号",
      "prop": "areaNum"
    }
  }, [_c('PhoneAreaSelect', {
    on: {
      "on-change": _vm.onAreaNumChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 13
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号码",
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手机号和微信号至少填一个"
    },
    model: {
      value: (_vm.insertUserParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "mobile", $$v)
      },
      expression: "insertUserParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.insertUserParam.password),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "password", $$v)
      },
      expression: "insertUserParam.password"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.insertUserParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "sex", _vm._n($$v))
      },
      expression: "insertUserParam.sex"
    }
  }, _vm._l((_vm.sexList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "等级",
      "prop": "userInfoLevelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": "",
      "clearable": ""
    },
    model: {
      value: (_vm.insertUserParam.userInfoLevelId),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "userInfoLevelId", _vm._n($$v))
      },
      expression: "insertUserParam.userInfoLevelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄",
      "prop": "age"
    }
  }, [_c('Input', {
    attrs: {
      "type": "number",
      "min": 0,
      "max": 150
    },
    model: {
      value: (_vm.insertUserParam.age),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "age", _vm._n($$v))
      },
      expression: "insertUserParam.age"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道",
      "prop": "regType"
    }
  }, [_c('channel-select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.insertUserParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "regType", $$v)
      },
      expression: "insertUserParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "adviserId",
      "label": "课程顾问："
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.insertUserParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "adviserId", _vm._n($$v))
      },
      expression: "insertUserParam.adviserId"
    }
  }, _vm._l((_vm.adviserList), function(item) {
    return _c('Option', {
      key: item.adviserId,
      attrs: {
        "value": item.adviserId
      }
    }, [_vm._v(_vm._s(item.adviserName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "rows": 3,
      "type": "textarea"
    },
    model: {
      value: (_vm.insertUserParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "remark", $$v)
      },
      expression: "insertUserParam.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.insertUserParam.files),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "files", $$v)
      },
      expression: "insertUserParam.files"
    }
  })], 1)], 1), _vm._v(" "), (_vm.insertUserParam.regType === 'tj') ? _c('Col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐学生Id",
      "prop": "inviteId"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.insertUserParam.inviteId),
      callback: function($$v) {
        _vm.$set(_vm.insertUserParam, "inviteId", _vm._n($$v))
      },
      expression: "insertUserParam.inviteId"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingInsertUser
    },
    on: {
      "click": _vm.insertUser
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cfa79c6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/modal/InsertUserModal.vue
// module id = 1636
// module chunks = 8